<template>
    <div class="row">
        <div class="col-sm-12">
            <form autocomplete="off"
                method="post"
                :disabled="loading"
                data-vv-scope="form"
                @keyup.enter="onBeforeSaveItem"
                @submit.prevent="onBeforeSaveItem">
                <div class="row mb-3">
                    <div class="col-sm-auto">
                        <h1 class="content-title">
                            {{ titleItem }}
                        </h1>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-3">
                        <div class="form-group">
                            <MaterialSelect
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-status"
                                name="status"
                                label="name"
                                :filterable="true"
                                :options="lists.onoff"
                                v-model.trim="form.status"
                                :reduce="option => option.code"
                                v-validate="'required'"
                                :inputClasses="[{'is-invalid': fnHasError('status') }]"
                                :error=" fnFirstError('status')"
                                :helpText="`${this.pageID}.help.status`">
                                {{ $t(`${pageID}.model.status`) }}
                            </MaterialSelect>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="form-group">
                            <MaterialInput
                                :readonly="readonlyFormItem"
                                type="number"
                                class="city-form-group city-bg"
                                id="input-order"
                                name="order"
                                v-model.trim="form.order"
                                v-validate="'required|integer|min_value:1'"
                                :inputClasses="[{'is-invalid': fnHasError('order') }]"
                                :error=" fnFirstError('order')"
                                :helpText="`${this.pageID}.help.order`">
                                {{ $t(`${pageID}.model.order`) }}
                            </MaterialInput>
                        </div>
                    </div>
                    <div class="col-sm-6" v-if="isItem">
                        <div class="form-group">
                            <MaterialSelect
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-regulation_id"
                                name="regulation_id"
                                label="name"
                                :filterable="true"
                                :options="lists.groups"
                                v-model.trim="form.regulation_id"
                                :indentText="true"
                                :indentationTarget="'regulation_id'"
                                v-validate="{required: isItem}"
                                :inputClasses="[{'is-invalid': fnHasError('regulation_id') }]"
                                :error=" fnFirstError('regulation_id')"
                                :helpText="`${this.pageID}.help.group`">
                                {{ $t(`${pageID}.model.regulation_id`) }}
                            </MaterialSelect>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="form-group">
                            <MaterialInput
                                :readonly="readonlyFormItem"
                                type="text"
                                class="city-form-group city-bg"
                                id="input-name"
                                name="name"
                                v-model.trim="form.name"
                                v-validate="'required|min:3'"
                                :inputClasses="[{'is-invalid': fnHasError('name') }]"
                                :error=" fnFirstError('name')">
                                {{ $t(`${pageID}.model.name`) }}
                            </MaterialInput>
                        </div>
                    </div>
                </div>

                <div class="row" v-if="isItem">
                    <div class="col-12">
                        <div class="row">
                            <div class="col">
                                <h6 class="font-weight-normal">
                                    {{ $t(`${pageID}.form.document.title`) }}
                                </h6>
                                <hr class="mt-2" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <MaterialInput
                                        :readonly="readonlyFormItem"
                                        type="text"
                                        class="city-form-group city-bg"
                                        id="input-url"
                                        name="url"
                                        v-model.trim="form.url"
                                        v-validate="'url'"
                                        :inputClasses="[{'is-invalid': fnHasError('url') }]"
                                        :error=" fnFirstError('url')"
                                        :helpText="`${this.pageID}.help.url`">
                                        {{ $t(`${pageID}.model.url`) }}
                                    </MaterialInput>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="doc">
                                    <upload-multiple-file
                                        :disabled="readonlyFormItem"
                                        name="filename"
                                        v-model="filename"
                                        :acceptTypes="acceptTypes"
                                        :maxFiles="maxFiles"
                                        v-validate="''"
                                        class="mb-0"
                                    >
                                    </upload-multiple-file>
                                    <help-span
                                        :helpText="`${this.pageID}.help.upload`" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <buttons-footer
                    :enableButtons="!readonlyFormItem"
                    :cancelTitle="cancelTitle"
                    :submitTitle="submitTitle"
                    :isDisabled="isDisabled"
                    @save="onBeforeSaveItem"
                    @cancel="handleBack"
                />
            </form>
        </div>
    </div>
</template>

<script>
    import GeneralMixin from './mixins/GeneralMixin';
    import {isArray} from '@config/utils';

    export default {
        name: 'RegulationDetails',
        mixins: [
            GeneralMixin
        ],
        components: {
            HelpSpan: () => import(/* webpackChunkName: "help-span" */ '@/components/form/HelpSpan.vue'),
            UploadMultipleFile: () => import(/* webpackChunkName: "upload-file" */ '@/components/form/UploadMultipleFile.vue'),
        },
        props: {
            id: {
                type: String,
                required: true,
            },
            groupTitle: {
                type: String,
                default: 'global.group',
            },
            // maxFiles: {
            //     type: Number,
            //     default: 1,
            // },
            // acceptTypes: {
            //     type: Array,
            //     default: () => ([
            //         'application/msword',
            //         'application/vnd.ms-excel',
            //         'application/vnd.ms-powerpoint',
            //         'application/pdf',
            //         'image/*',
            //     ]),
            // },
        },
        data() {
            return {
                pageID: null,
                pageTitle: 'Details',
                loading: false,
                lists: {
                    groups: [],
                },
                form: {
                    id: null,
                    behavior: null,
                    regulation_id: null,
                    name: null,
                    url: null,
                    order: 1,
                    collapsed: false,
                    status: 1,
                    filename: null,
                },
                filename: [],
            }
        },
        beforeMount() {
            this.pageID = this.id;
        },
        mounted() {
            if(this.$route.params.type){
                this.form.behavior = this.$route.params.type;
            }

            this.loadLists();
        },
        computed: {
            detailTitle() {
                return this.isItem ? this.pageTitle : this.$t(this.groupTitle);
            },
            titleItem() {
                return (this.form.id ? this.updateTitle : this.addTitle) + ' - ' + this.detailTitle;
            },
            isItem() {
                return this.form.behavior == 'item';
            },
            panelCfg() {
                return this.panel?.panel ?? {};
            },
            filesCfg() {
                return this.panelCfg?.files ?? {};
            },
            maxFiles() {
                return this.filesCfg?.maxFiles ?? 1;
            },
            acceptTypes() {
                return (this.filesCfg?.mimeTypes ?? [
                    'application/msword',
                    'application/vnd.ms-excel',
                    'application/vnd.ms-powerpoint',
                    'application/pdf',
                    'image/*',
                ]).join(", ");
            },
        },
        methods: {
            onBeforeSaveItem() {
                this.saveItemOldWay(`${this.moduleInternalCode}.${this.id}`, ['filename']);
            },
            callbackLoadItem: function() {
                ['filename'].forEach(k => {
                    if(this.form[k]){
                        if(isArray(this.form[k])){
                            this.form[k].forEach( item => {
                                this[k].push(Object.assign(item, {
                                    'name': this.form[k].replace(/^.*[\\\/]/, ''),
                                    'path': this.getFormatUrlAPI(item.filename),
                                }));
                            })
                        }else{
                            this[k].push({
                                'name': this.form[k].replace(/^.*[\\\/]/, ''),
                                'path': this.getFormatUrlAPI(this.form[k])
                            });
                        }
                    }
                });
            },
            forceDirtyUpload: function(key){
                if(this.fields.$form && this.fields.$form[key]){
                    this.fields.$form[key].dirty=true;
                }
            },
        },
        watch:{
            'filename': {
                deep: true,
                handler(value, oldValue){
                    this.forceDirtyUpload('filename');
                },
            },
        }

    }
</script>

<style scoped lang="scss">

</style>
